// extracted by mini-css-extract-plugin
export default {"container":"Course_container__ic++P","frameWrapper":"Course_frameWrapper__gDSwC","iframe":"Course_iframe__j84AK","Spin":"Course_Spin__gb1DM"};